/**
 * Application Constants
 *
 * Central location for all application-wide constants including
 * storage keys, thresholds, and configuration values.
 */

/**
 * Storage keys for Capacitor Preferences
 */
export const STORAGE_KEYS = {
    AUTH_TOKEN: 'auth_token',
    USER_PROFILE: 'user_profile',
    APP_CONFIG: 'app_config'
} as const

/**
 * Token refresh threshold in days
 * Token should be refreshed when this many days remain before expiration
 */
export const TOKEN_REFRESH_THRESHOLD_DAYS = 7

/**
 * Acceptable GPS accuracy threshold in meters
 * GPS accuracy must be ≤50 meters to be considered acceptable
 */
export const ACCEPTABLE_GPS_ACCURACY = 50

/**
 * Geofence thresholds (to be added in future stories)
 */
export const GEOFENCE_THRESHOLD_METERS = 100

/**
 * Maximum sync retry attempts (to be added in future stories)
 */
export const MAX_SYNC_RETRIES = 3

/**
 * Current web bundle version
 * Bump this with each web release to enable OTA update detection.
 * The server's /api/warden/version endpoint returns the latest version;
 * if it's greater than this, an OTA update is triggered.
 */
export const APP_WEB_VERSION = '2.1.5'
